import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Dialog,
  FlatButton
} from 'material-ui';


export default class ModalWithChildren extends Component {
  constructor(props){
    super(props);
    var date = new Date(props.project.information.start_date)
    this.state = {
      open: true,
      project: {
        id: props.project.id,
        economicImpact: props.project.information.economic_impact,
        solutionType: props.project.options.filter((selection) => {return selection.filter_id === 1}).map((selection) => {return selection.option.name}),
        benefitType: props.project.options.filter((selection) => {return selection.filter_id === 21}).map((selection) => {return selection.option.name}),
        novelty: props.project.options.filter((selection) => {return selection.filter_id === 11}).map((selection) => {return selection.option.name})[0],
        implementationDate: new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()),
        name: props.project.information.name,
        leaderFirstName: props.project.information.leader_first_name,
        leaderLastName: props.project.information.leader_last_name,
        leaderEmail: props.project.information.leader_email,
        problem: props.project.information.problem,
        solution: props.project.information.solution,
        benefits: props.project.information.benefits,
        sponsor: props.project.information.sponsor_first_name + ' ' + props.project.information.sponsor_last_name,
        area: props.project.information.area.name
      }
    };
  }

  handleConfirm = () => {
    this.props.confirm(this.state.project);
    this.handleClose();
  };

  handleCancel = () => {
    this.props.cancel();
    this.handleClose();
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="Aceptar"
        primary={true}
        onClick={this.handleCancel}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleCancel}
          autoScrollBodyContent={true}
          contentStyle={{maxWidth:'none'}}
        >
        {
           React.cloneElement(
             this.props.children,{
               handleSelectChange: this.handleSelectChange,
               handleDateChange: this.handleDateChange,
               handleTextChange: this.handleTextChange,
               handleCheckboxChange: this.handleCheckboxChange,
             }
           )
         }
        </Dialog>
      </div>
    );
  }

  handleSelectChange = (event, value) => {
    this.setState({ project: { ...this.state.project, novelty: value} });
  }

  handleDateChange = (event, date) => {
    this.setState({ project: { ...this.state.project, implementationDate: date} });
  }

  handleTextChange = (event, type) => {
    this.setState({ project: { ...this.state.project, [type]: event.target.value} });
  }

  handleCheckboxChange = (type, option) => {
    var index = this.state.project[type].indexOf(option);
    if(index === -1){
      this.setState({ project: { ...this.state.project, [type]: [...this.state.project[type], option]} })
    }
    else {
      this.setState((prevState) => ({
        project: { ...this.state.project, [type]: prevState.project[type].filter((_,i) => i !== index) }
      }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/design/ModalWithChildren.js